module.exports = __webpack_public_path__ + "static/img/2.9bc4f9b3.png";